import type { ILineDetails } from '../../../../models/line-details.model';
import type { TransportMode } from '../../../../models/transport-mode.enum';
import type { TransportSubMode } from '../../../../models/transport-sub-mode.enum';

export class LineDetailsApiModel {
  public static mapToBusinessModel(apiModel: LineDetailsApiModel): ILineDetails {
    return {
      name: apiModel.name,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      transportMode: apiModel.transportMode,
      transportSubMode: apiModel.transportSubMode,
      isPublicTransport: apiModel.isPublicTransport,
    };
  }

  public name!: string;
  public backgroundColor!: string;
  public foregroundColor!: string;
  public transportMode!: TransportMode;
  public transportSubMode!: TransportSubMode;
  public isPublicTransport!: boolean;
}
